import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './InvoicesPage.css';

const API_URL = '/api';

export default function InvoicesPage() {
  const [invoices, setInvoices] = useState([]);
  const [file, setFile] = useState(null);
  const [meta, setMeta] = useState({ amount: '', vendor: '', invoice_date: '', description: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadInvoices();
  }, []);

  const loadInvoices = async () => {
    try {
      const res = await axios.get(`${API_URL}/invoices`);
      setInvoices(res.data);
    } catch (err) {
      console.error('Erreur:', err);
      alert('Impossible de charger les factures');
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return alert('Sélectionner un fichier');
    setLoading(true);
    try {
      const form = new FormData();
      form.append('file', file);
      form.append('amount', meta.amount || '');
      form.append('vendor', meta.vendor || '');
      form.append('invoice_date', meta.invoice_date || '');
      form.append('description', meta.description || '');

      const res = await axios.post(`${API_URL}/invoices/upload`, form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setFile(null);
      setMeta({ amount: '', vendor: '', invoice_date: '', description: '' });
      loadInvoices();
      alert('Facture uploadée');
    } catch (err) {
      console.error(err);
      alert('Erreur upload: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette facture ?')) return;
    try {
      await axios.delete(`${API_URL}/invoices/${id}`);
      loadInvoices();
    } catch (err) {
      console.error(err);
      alert('Erreur suppression');
    }
  };

  return (
    <div className="invoices-page">
      <div className="invoices-header">
        <h2>📄 Factures</h2>
      </div>

      <form className="invoice-form card" onSubmit={handleUpload}>
        <div className="form-row">
          <label>Fichier</label>
          <input type="file" onChange={(e) => setFile(e.target.files[0])} />
        </div>
        <div className="form-row">
          <label>Montant</label>
          <input type="number" step="0.01" value={meta.amount} onChange={(e) => setMeta({...meta, amount: e.target.value})} />
        </div>
        <div className="form-row">
          <label>Fournisseur</label>
          <input value={meta.vendor} onChange={(e) => setMeta({...meta, vendor: e.target.value})} />
        </div>
        <div className="form-row">
          <label>Date</label>
          <input type="date" value={meta.invoice_date} onChange={(e) => setMeta({...meta, invoice_date: e.target.value})} />
        </div>
        <div className="form-row">
          <label>Description</label>
          <input value={meta.description} onChange={(e) => setMeta({...meta, description: e.target.value})} />
        </div>
        <div className="form-row">
          <button className="btn btn-primary" type="submit" disabled={loading}>{loading ? 'Upload...' : 'Uploader la facture'}</button>
        </div>
      </form>

      <div className="invoices-list">
        {invoices.map(inv => (
          <div key={inv.id} className="invoice-card card">
            <div className="invoice-left">
              <strong>{inv.original_name}</strong>
              <div className="muted">{inv.vendor || '—'} • {inv.invoice_date || '—'}</div>
            </div>
            <div className="invoice-right">
              <div className="amount">{inv.amount ? `${inv.amount} €` : '—'}</div>
              <button className="btn" onClick={() => window.open(`/api/invoices/download/${inv.id}`, '_blank')}>Télécharger</button>
              <button className="btn btn-danger" onClick={() => handleDelete(inv.id)}>Supprimer</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
